<template lang="pug">
.table-responsive
  table.table.table-sm.mb-0
    thead
      tr.border-top-0
        th.text-center {{ $t('components.project_group_slot_table.tpl.access') }}
        th.text-center {{ $t('components.project_group_slot_table.tpl.profile') }}
    tbody
      project-group-slot-table-item(
        v-for="(slot, index) in projectGroup.slots"
        :key="index"
        :index="index+1"
        :item="slot"
        :crd-project="crdProject"
      )
</template>

<script>
import ProjectGroupSlotTableItem from '@/components/ProjectGroupSlotTableItem';

export default {
  components: {
    ProjectGroupSlotTableItem,
  },
  props: {
    projectGroup: {
      type: Object,
      required: true,
    },
    crdProject: {
      type: Object,
      required: false,
      default() { return null; },
    },
  },
};
</script>
